export default __webpack_public_path__ + "static/media/Vanshaj Johri.d2c94344.jpg";